import {
  type PharmacyPeriodFilter,
  type PurchasesChannelName,
  useFinancialDataPurchasesApi,
} from "@pharmupp/p3-front-commons"

const PINNED_CHANNELS: PurchasesChannelName[] = [
  "FDL",
  "DIRECT",
  "SAGITTA",
  "COALIA",
  "PHARMAT",
  "RETROCESSION",
]

export const useMyPharmacyPurchases = (params: PharmacyPeriodFilter) => {
  return useFinancialDataPurchasesApi({
    params: { pharmacyId: undefined, ...params },
    pinnedChannels: PINNED_CHANNELS,
  })
}
